import React from 'react';
import Fetch from '../components/Fetch';
import ArticleList from '../components/ArticleList';

export default function Article() {
  return (
    <div className="article-page" style={{ padding: '20px' }}>
      <h1>Artikel</h1>
      <Fetch>
        {({ data, loading, error }) => {
          if (loading) return <p>Loading...</p>;
          if (error) return <p>Error loading articles.</p>;

          const articles = data?.filter(item => item.content_type === 'article') || [];
          const sortedArticles = articles.sort((a, b) => new Date(b.date_created) - new Date(a.date_created));
          return <ArticleList articles={sortedArticles} />;
        }}
      </Fetch>
    </div>
  );
}